/**
 * 85. Dashboard Builder — not available yet (REP-BUILDERS, D661).
 *
 * The page listed `Dashboard` rows under columns the table lacks
 * (description, widget count, owner, sharing) and read `isDefault` and
 * `updatedAt` where the API sends `is_default` and `updated_at`, so those
 * rendered empty; "New dashboard" had no handler, and no screen calls
 * `GET /v1/dashboards/:id/data`. No build slice is planned for it, so the
 * page names the register row instead.
 */
import { NotAvailablePage } from "@/components/NotAvailable";
import { useTranslation } from "@/lib/i18n";

export function DashboardBuilderPage() {
  const { t } = useTranslation();
  return (
    <NotAvailablePage
      title={t("nav.dashboardBuilder")}
      message={t("notAvailable.dashboardBuilder")}
      reason="unplanned"
      slice="D661"
    />
  );
}
